var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { Dialog, Typography, Link } from '@material-ui/core';
import { getLinkTextFromDate } from './Utils';
import { ClosableDialogTitle, ClosableDialogContent } from '.';
// eslint-disable-next-line max-len
// This resolves to nothing and doesn't affect browser history and without it will not change the mouse icon as clickable when it hover over the link.
// eslint-disable-next-line no-script-url
var dudUrl = 'javascript:;';
var ClosableDialogLink = /** @class */ (function (_super) {
    __extends(ClosableDialogLink, _super);
    function ClosableDialogLink() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // eslint-disable-next-line react/state-in-constructor
        _this.state = {
            open: false,
        };
        _this.handleClickOpen = function (e) {
            _this.setState({ open: true });
            e.stopPropagation();
        };
        _this.handleClose = function () {
            _this.setState({ open: false });
        };
        return _this;
    }
    ClosableDialogLink.prototype.render = function () {
        // TODO: Language should be in the context or I18N. Change when I18N it's DONE.
        var languageSelected = 'English';
        var lastUpdateDate = this.props.lastUpdateDate;
        var linkText;
        if (lastUpdateDate) {
            linkText = getLinkTextFromDate(lastUpdateDate.toString(), languageSelected);
        }
        else {
            linkText = 'Not Started';
        }
        return (React.createElement("div", null,
            React.createElement(Typography, null,
                React.createElement(Link, { href: dudUrl, variant: "body2", color: "inherit", onClick: this.handleClickOpen }, linkText)),
            React.createElement(Dialog, { onClick: function (e) { e.stopPropagation(); }, onClose: this.handleClose, "aria-labelledby": "customized-dialog-title", open: this.state.open, fullWidth: true, maxWidth: "xl" },
                React.createElement(ClosableDialogTitle, { onClose: this.handleClose }, this.props.title),
                React.createElement(ClosableDialogContent, { dividers: true }, this.props.children))));
    };
    return ClosableDialogLink;
}(React.Component));
export default ClosableDialogLink;
//# sourceMappingURL=ClosableDialogLink.js.map